<div class="row justify-content-center">
            <div class="col-md-3">
                <div id="accordion-c1" class="accordion">
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" href="#clar-1">
                        <a class="card-title">1.1</a>
                        </div>
                        <div id="clar-1" class="card-body collapse in show" data-parent="#accordion-c1" >
                            <a href="https://docs.google.com/spreadsheets/d/1wyBzH3TgDAXPVPU6ZbErRIkojhVbVn8G/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                1.1 Criteria Clarifications
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c1" href="#clar-2">
                        <a class="card-title">1.1.2</a>
                        </div>
                        <div id="clar-2" class="card-body collapse" data-parent="#accordion-c1" >
                            <a href="https://docs.google.com/spreadsheets/d/1E8ah6e6VcFKJptmtb0YqjFtRoUaamv3t/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                1.1.2
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c1" href="#clar-3">
                        <a class="card-title">1.2.1</a>
                        </div>
                        <div id="clar-3" class="card-body collapse" data-parent="#accordion-c1" >
                            <a href="https://docs.google.com/spreadsheets/d/1M_FFA2p41O7FtG0nkwr5adO4OSrTFjJX/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                1.2.1
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c1" href="#clar-4">
                        <a class="card-title">2.1.1</a>
                        </div>
                        <div id="clar-4" class="card-body collapse" data-parent="#accordion-c1" >
                            <a href="https://drive.google.com/file/d/1wohgIysPvGXD9nQtnTFn0airxVHuYbqX/view?usp=sharing" target="_blank" class="btn-link">
                                2.1.1
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c1" href="#clar-5">
                        <a class="card-title">2.1.3</a>
                        </div>
                        <div id="clar-5" class="card-body collapse" data-parent="#accordion-c1" >
                            <a href="https://drive.google.com/file/d/1qyqxE31hhr_BYWyXverFcDqMJi-eC1at/view?usp=sharing" target="_blank" class="btn-link">
                                2.1.3
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c1" href="#clar-6">
                        <a class="card-title">6.2.3</a>
                        </div>
                        <div id="clar-6" class="card-body collapse" data-parent="#accordion-c1" >
                            <a href="https://drive.google.com/file/d/1YGHRkROe_YARyFTiIcwA2NBwxWfKshUA/view?usp=sharing" target="_blank" class="btn-link">
                                6.2.3
                        </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c1" href="#clar-7">
                        <a class="card-title">6.3.4</a>
                        </div>
                        <div id="clar-7" class="card-body collapse" data-parent="#accordion-c1" >
                            <a href="https://drive.google.com/file/d/1o7Z8k3KI5CyKhC_RmG33nwYCsMpX1p8a/view?usp=sharing" target="_blank" class="btn-link">
                                6.3.4
                        </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c1" href="#clar-8">
                        <a class="card-title">2.6.3</a>
                        </div>
                        <div id="clar-8" class="card-body collapse" data-parent="#accordion-c1" >
                            <a href="https://drive.google.com/file/d/1zOKFJvMOH5wHcbVVblDW3ad9rSqiiTXX/view?usp=sharing" target="_blank" class="btn-link">
                                2.6.3
                        </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c1" href="#clar-9">
                        <a class="card-title">3.2.2</a>
                        </div>
                        <div id="clar-9" class="card-body collapse" data-parent="#accordion-c1" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1KnMHdRuL-fgjzBNoFQhk-PI8fKDgPGo2/view?usp=sharing" target="_blank" class="btn-link">
                                        3.2.2 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1WFfXKElfd0pXEBu5YYEP9KYuQYTXbzio/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        3.2.2 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div id="accordion-c2" class="accordion">                    
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c2" href="#clar-10">
                        <a class="card-title">3.3.4</a>
                        </div>
                        <div id="clar-10" class="card-body collapse" data-parent="#accordion-c2" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1BcIGecFW0RJWHVumcikUhPRly054zx-d/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        3.3.4 Exel
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/18XhkcZ8Q7ljpfTkHasORnDkjHo89SdMg/view?usp=sharing" target="_blank" class="btn-link">
                                        3.3.4 PDF
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c2" href="#clar-11">
                        <a class="card-title">3.3.5</a>
                        </div>
                        <div id="clar-11" class="card-body collapse" data-parent="#accordion-c2" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1vae36am3pN38DUdPV7szZn_pgf_lw33i/view?usp=sharing" target="_blank" class="btn-link">
                                        3.3.5
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1DiBsnGINf6MlDJjsYXWOw1FiaTU4wvUF/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        3.3.5 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c2" href="#clar-12">
                        <a class="card-title">3.5.2</a>
                        </div>
                        <div id="clar-12" class="card-body collapse" data-parent="#accordion-c2" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1UCQ_j5lTAGaTGiaH81v5JquKkZXBc9Bz/view?usp=sharing" target="_blank" class="btn-link">
                                        3.5.2 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1RBNkuPDDserwg83na4tj9_divfj6IIZB/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        3.5.2 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c2" href="#clar-13">
                        <a class="card-title">5.1.3</a>
                        </div>
                        <div id="clar-13" class="card-body collapse" data-parent="#accordion-c2" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/126uFIbKVpBJ544iXmxGOdarHQX0BicE0/view?usp=sharing" target="_blank" class="btn-link">
                                        5.1.3 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1JLBAwbO0AqX0Pbsm5qzXQ8onSDbKXBwT/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        5.1.3 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c2" href="#clar1-14">
                        <a class="card-title">5.1.4</a>
                        </div>
                        <div id="clar1-14" class="card-body collapse" data-parent="#accordion-c2" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1v7b7F69pkFLZihDxRfG4Gu9HZEz8f2EU/view?usp=sharing" target="_blank" class="btn-link">
                                        5.1.4 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1LeXMjlyrymLRcbe8FWJRwdgKxwsidj15/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        5.1.4 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c2" href="#clar-15">
                        <a class="card-title">5.3.3</a>
                        </div>
                        <div id="clar-15" class="card-body collapse" data-parent="#accordion-c2" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1_0E2CXiJfQ8EuY8--6-eQvFtMuls5a30/view?usp=sharing" target="_blank" class="btn-link">
                                        5.3.3 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1DDk8C5Qiym4qRLsB0KmGPhAlftYFCbFY/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        5.3.3 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c2" href="#clar-16">
                        <a class="card-title">5.1.5</a>
                        </div>
                        <div id="clar-16" class="card-body collapse" data-parent="#accordion-c2" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1CZSmcu-CsZRgU7XIYKWZhkrJWTKcHwig/view?usp=sharing" target="_blank" class="btn-link">
                                        5.1.5 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1j0zFmTA1NfO5ByF3JYVAh4a7WJVfEDlW/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        5.1.5 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c2" href="#clar-17">
                        <a class="card-title">5.2.3</a>
                        </div>
                        <div id="clar-17" class="card-body collapse" data-parent="#accordion-c2" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1qZpfOkf6NMUg6NhJyOkLQhY9yhjOIlzY/view?usp=sharing" target="_blank" class="btn-link">
                                        5.2.3 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1g2XBqvQCoaYdT6xvl9viPItdxKqJkn79/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        5.2.3 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c2" href="#clar-18">
                        <a class="card-title">5.3.1</a>
                        </div>
                        <div id="clar-18" class="card-body collapse" data-parent="#accordion-c2" >
                            <a href="https://drive.google.com/file/d/1koWJS4jAxqvXXMTRKAcyr-BrMQdMJZ-p/view?usp=sharing" target="_blank" class="btn-link">
                                5.3.1 Pdf
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c2" href="#clar-19">
                        <a class="card-title">7.1.1</a>
                        </div>
                        <div id="clar-19" class="card-body collapse" data-parent="#accordion-c2" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/11uyuJGGcUbedxQSr-Hmee8HAwNW5uS3O/view?usp=sharing" target="_blank" class="btn-link">
                                        7.1.1 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1byH7QWJLRtj1SH9gCNTHFIVPf7TpIKzu/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        7.1.1 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div id="accordion-c3" class="accordion">                    
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-20">
                        <a class="card-title">1.2.3</a>
                        </div>
                        <div id="clar-20" class="card-body collapse" data-parent="#accordion-c3" >
                            <a href="https://drive.google.com/file/d/1_BlCJbkVkbk0Ne3d9iw16ZEWsmUTnKym/view?usp=sharing" target="_blank" class="btn-link">
                                1.2.3
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-21">
                        <a class="card-title">1.3.2</a>
                        </div>
                        <div id="clar-21" class="card-body collapse" data-parent="#accordion-c3" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1RkICm_ADGGAE_FOkZCRgcTwm7PC28_76/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        1.3.2 exel
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1mCyRmrlD2QdbDEj319dUdqaX2rTCWxf1/view?usp=sharing" target="_blank" class="btn-link">
                                        1.3.2 pdf
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-22">
                        <a class="card-title">1.3.3</a>
                        </div>
                        <div id="clar-22" class="card-body collapse" data-parent="#accordion-c3" >
                            <a href="https://drive.google.com/file/d/1Mru0OxkpgpzBKMleg5zNBerPAKI6yVb8/view?usp=sharing" target="_blank" class="btn-link">
                                1.3.3
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-23">
                        <a class="card-title">2.1.3</a>
                        </div>
                        <div id="clar-23" class="card-body collapse" data-parent="#accordion-c3" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1Kg3QQgOt7gZuUaRxHZ4dSjWm_gHZSmHi/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        2.1.3 Exel
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1qyqxE31hhr_BYWyXverFcDqMJi-eC1at/view?usp=sharing" target="_blank" class="btn-link">
                                        2.1.3 Pdf
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-24">
                        <a class="card-title">2.2.2</a>
                        </div>
                        <div id="clar-24" class="card-body collapse" data-parent="#accordion-c3" >
                            <a href="https://drive.google.com/file/d/13qw_HjfXNCTzZlU680FAvUKuZr8p9IHE/view?usp=sharing" target="_blank" class="btn-link">
                                2.2.2
                           </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-25">
                        <a class="card-title">3.1</a>
                        </div>
                        <div id="clar-25" class="card-body collapse" data-parent="#accordion-c3" >
                            <a href="https://drive.google.com/file/d/1LjdGToUkRN4gxP0h9bPi8LxcOnXrrfi6/view?usp=sharing" target="_blank" class="btn-link">
                                3.1
                           </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-26">
                        <a class="card-title">3.2</a>
                        </div>
                        <div id="clar-26" class="card-body collapse" data-parent="#accordion-c3" >
                            <a href="https://drive.google.com/file/d/1GSV6YmDtzxy547bPe4c7ANisfTOGOiCt/view?usp=sharing" target="_blank" class="btn-link">
                                3.2
                           </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-27">
                        <a class="card-title">3.4.2</a>
                        </div>
                        <div id="clar-27" class="card-body collapse" data-parent="#accordion-c3" >
                            <a href="https://drive.google.com/file/d/178kYa_QAtd-as-_37pnDbhkAhtmPOJi2/view?usp=sharing" target="_blank" class="btn-link">
                                3.4.2
                           </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-28">
                        <a class="card-title">6.5.3</a>
                        </div>
                        <div id="clar-28" class="card-body collapse" data-parent="#accordion-c3" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1uiFhPlXuDpkaNXtQy4NVWa5UhXR7BjE_/view?usp=sharing" target="_blank" class="btn-link">
                                         6.5.3 PDF

                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1JZ_QVPGbM2ydsG-HjlkwKN5N12F33d3v/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                         6.5.3 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-29">
                        <a class="card-title">6.5.4</a>
                        </div>
                        <div id="clar-29" class="card-body collapse" data-parent="#accordion-c3" >
                            <a href="https://drive.google.com/file/d/1idsMXSJACSopQTBZMexZ3uJha5WcPaFo/view?usp=sharing" target="_blank" class="btn-link">
                                6.5.4
                           </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c3" href="#clar-30">
                        <a class="card-title">3.3.2</a>
                        </div>
                        <div id="clar-30" class="card-body collapse" data-parent="#accordion-c3" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1ksTzeg349oNMahx3pKFss-peMU6GWOQG/view?usp=sharing" target="_blank" class="btn-link">
                                        3.3.2 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1gYJJ5Fxku2uYxpBrSbylZfHy921qNG4N/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true    " target="_blank" class="btn-link">
                                        3.3.2 EXEL
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div id="accordion-c4" class="accordion">                    
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-31">
                        <a class="card-title">3.4.4</a>
                        </div>
                        <div id="clar-31" class="card-body collapse" data-parent="#accordion-c4" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1Q0B1CfyMyhHgowc2f54lNSQPEzz4xnyZ/view?usp=sharing" target="_blank" class="btn-link">
                                        3.4.4 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1GD3ZKKVQJRqu37ih1GHrlBRayNnm30p5/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        3.4.4 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-32">
                        <a class="card-title">3.5.1</a>
                        </div>
                        <div id="clar-32" class="card-body collapse" data-parent="#accordion-c4" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1JzdKVGAVMXFWeLFQWQbZNL1jGdX4s7ni/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        3.5.1 EXEL
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1dnZf45R_EK_2nGb9bBjUml8gdsZDknr3/view?usp=sharing" target="_blank" class="btn-link">
                                        3.5.1 PDF
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-33">
                        <a class="card-title">6.3.2</a>
                        </div>
                        <div id="clar-33" class="card-body collapse" data-parent="#accordion-c4" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/163mWDktBUn9Phyi7HMSr1RChh9iHZU14/view?usp=sharing" target="_blank" class="btn-link">
                                        6.3.2 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1tW-2GwC9ySbfNgWZ72u6WI4f9zeZ2Wdg/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        6.3.2 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-34">
                        <a class="card-title">4.1.3</a>
                        </div>
                        <div id="clar-34" class="card-body collapse" data-parent="#accordion-c4" >
                            <a href="https://drive.google.com/file/d/1YfBEamurYZT8kcmc0zXpl0VpE9ppOgXy/view?usp=sharing" target="_blank" class="btn-link">
                                4.1.3
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-35">
                        <a class="card-title">4.2.5</a>
                        </div>
                        <div id="clar-35" class="card-body collapse" data-parent="#accordion-c4" >
                            <a href="https://drive.google.com/file/d/1eETqt3_pD1zFV8qUtJHvLLlB0Gg_1vwd/view?usp=sharing" target="_blank" class="btn-link">
                                4.2.5 Pdf
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-36">
                        <a class="card-title">4.3.2</a>
                        </div>
                        <div id="clar-36" class="card-body collapse" data-parent="#accordion-c4" >
                            <a href="https://drive.google.com/file/d/1fBLwBSN7tbYP7C53FTjCgNvZO2lwgQww/view?usp=sharing" target="_blank" class="btn-link">
                                4.3.2 Pdf
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-37">
                        <a class="card-title">4.3.3</a>
                        </div>
                        <div id="clar-37" class="card-body collapse" data-parent="#accordion-c4" >
                            <a href="https://drive.google.com/file/d/142PlCQIBcS0Orjnp_auEYsi554sezdHK/view?usp=sharing" target="_blank" class="btn-link">
                                4.3.3 Pdf
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-38">
                        <a class="card-title">4.3.4</a>
                        </div>
                        <div id="clar-38" class="card-body collapse" data-parent="#accordion-c4" >
                            <a href="https://drive.google.com/file/d/1x6Cd72FSHgAkYZxMwoO1tvB0-TAIdML4/view?usp=sharing" target="_blank" class="btn-link">
                                4.3.4 Pdf
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-39">
                        <a class="card-title">7.1.9</a>
                        </div>
                        <div id="clar-39" class="card-body collapse" data-parent="#accordion-c4" >
                            <a href="https://drive.google.com/file/d/1F0TGROq3yU0Gy6z4CI9WLa_tWK-P8cYA/view?usp=sharing" target="_blank" class="btn-link">
                                7.1.9 Pdf
                            </a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-40">
                        <a class="card-title">7.1.10</a>
                        </div>
                        <div id="clar-40" class="card-body collapse" data-parent="#accordion-c4" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1MybB7LjMkp7ap5VrNM02cII9nBKGwnu8/view?usp=sharing" target="_blank" class="btn-link">
                                        7.1.10 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1ChJbxwnaSUvZ4vWqHXoW4xigzFviLT0a/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        7.1.10 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion-c4" href="#clar-41">
                        <a class="card-title">7.1.11</a>
                        </div>
                        <div id="clar-41" class="card-body collapse" data-parent="#accordion-c4" >
                            <div class="row"> 
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://drive.google.com/file/d/1xfPbSzevrj_9zE8bJ75Gw4BteWFnJj81/view?usp=sharing" target="_blank" class="btn-link">
                                        7.1.11 Pdf
                                    </a>
                                </div>
                                <div class="col-md-6 col-sm-12"> 
                                    <a href="https://docs.google.com/spreadsheets/d/1DKnQYA8xkHAEXAR_CaP_6AvCv2Zn4cEF/edit?usp=sharing&ouid=109589624472401135606&rtpof=true&sd=true" target="_blank" class="btn-link">
                                        7.1.11 Exel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>